export default __webpack_public_path__ + "static/media/capaEdp.213dfa5a.jpg";